import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import AsideOpenButton from './AsideOpenButton'

import PianoIcon from '../../assets/piano.png'
import VrHeadsetIcon from '../../assets/vr-headset.png'

const AsideControls = ({
  asidesContent,
  canPlayImmersive,
  openAsideType,
  openAsideHandler,
}) => {
  const { immersive } = asidesContent

  return (
    <Fragment>
      {canPlayImmersive && (
        <AsideOpenButton
          kind={'immersive'}
          image={VrHeadsetIcon}
          children={'Immersive'}
          openAsideHandler={openAsideHandler}
          disabled={immersive.length === 0}
          active={openAsideType === 'immersive'}
        />
      )}
      <AsideOpenButton
        kind={'description'}
        image={PianoIcon}
        children={'Instruments'}
        openAsideHandler={openAsideHandler}
        active={openAsideType === 'description'}
      ></AsideOpenButton>
    </Fragment>
  )
}

export default AsideControls

AsideControls.propTypes = {
  asidesContent: PropTypes.object.isRequired,
  openAsideType: PropTypes.string.isRequired,
  openAsideHandler: PropTypes.func.isRequired,
}
